export const translations = {
  tr: {
    nav: { services: "Hizmetler", pricing: "Fiyatlandırma", about: "Hakkımızda", contact: "İletişim", login: "Giriş", register: "Kayıt Ol", dashboard: "Panel", logout: "Çıkış", profile: "Profil" },
    hero: {
      eyebrow: "B2B • Veri Zekâsı Platformu",
      title_a: "Şirketinizin",
      title_b: "dijital izini",
      title_c: "ölçülebilir kılın.",
      subtitle: "Aqion; detaylı şirket analizi, SEO denetimi, veri kazıma ve otonom AI ajanlarını tek bir abonelikte birleştirir.",
      cta_primary: "Ücretsiz Başla",
      cta_secondary: "Hizmetleri İncele",
    },
    marquee: ["Şirket Analizi", "SEO Denetimi", "Veri Kazıma", "AI Ajanları", "Canlı Zekâ", "API & PDF Raporlar", "Çoklu Bölge"],
    services: {
      eyebrow: "Hizmetler",
      title: "Tek platform. Dört motor.",
      desc: "Karar destek için tasarlanmış, kurumsal sınıf modüller.",
      details: "Detay",
      items: [
        { key: "company", title: "Şirket Analizi", desc: "Finans, pazar konumu, rakip kıyaslaması ve risk profili. PDF ve API çıktısı." },
        { key: "seo", title: "SEO Analizi", desc: "Teknik SEO, anahtar kelime fırsatları, içerik stratejisi ve backlink denetimi." },
        { key: "scraper", title: "Web Scraper", desc: "Antibot atlatmalı, planlanabilir veri toplama. Yapılandırılmış JSON ve CSV." },
        { key: "agent", title: "AI Agent", desc: "İş süreçlerinizi yöneten, hedef odaklı otonom AI ajanları. 7/24 çalışır." },
      ],
    },
    features: [
      { icon: "zap", title: "Gerçek zamanlı zekâ", desc: "Veriler dakikalar içinde panelinize akar." },
      { icon: "shield", title: "Kurumsal güvenlik", desc: "ISO 27001 ilkelerine uygun. Şifreli saklama, ayrı tenant." },
      { icon: "globe", title: "Çoklu bölge", desc: "Avrupa ve ABD veri merkezleri, 12 dilde işleme." },
      { icon: "spark", title: "Otonom ajanlar", desc: "Hedef tanımlayın, ajanlar süreci yürütsün." },
    ],
    about: {
      eyebrow: "Neden Aqion",
      title: "Veriden karara, otomatik.",
      desc: "Manuel rapor yerine canlı zekâ. Rakipleri izleyin, fırsatları yakalayın, ajanlarla harekete geçin.",
      stats: [
        { v: "1.2M+", l: "Aylık veri talebi" },
        { v: "%99,7", l: "SLA hizmet süresi" },
        { v: "<3 dk", l: "Rapor üretim süresi" },
        { v: "AB+ABD", l: "Veri merkezleri" },
      ],
    },
    testimonials: {
      eyebrow: "Referanslar",
      title: "Sonuç odaklı ekipler Aqion ile çalışıyor.",
      items: [
        { quote: "Aqion sayesinde rakip analizini haftalardan saatlere indirdik.", who: "Defne Aksoy", role: "CMO, Kuzey Holding" },
        { quote: "AI Agent modülü, içerik takvimimizi tek başına yönetiyor.", who: "Mert Erkan", role: "Büyüme Direktörü, Lumen" },
        { quote: "Scraper antibot performansı kategorisinde rakipsiz.", who: "Aslı Demir", role: "Veri Lideri, Orbit" },
      ],
    },
    pricing: {
      eyebrow: "Fiyatlandırma",
      title: "Ekibinize uyan plan.",
      desc: "Aylık abonelik. İstediğiniz zaman iptal edin.",
      month: "/ay",
      popular: "Popüler",
      cta: "Planı Seç",
      cta_login: "Üye Olup Devam Et",
      goto: "Fiyatlandırmaya git",
      tiers: {
        starter: { name: "Starter", desc: "Bireyler ve küçük ekipler için.", features: ["Aylık 100 analiz", "Temel SEO denetimi", "1 zamanlanmış scraper", "E-posta desteği"] },
        pro: { name: "Pro", desc: "Büyüyen ekipler ve ajanslar için.", features: ["Aylık 1.000 analiz", "Gelişmiş SEO ve rakip izleme", "10 zamanlanmış scraper", "1 AI Agent", "Öncelikli destek"] },
        enterprise: { name: "Enterprise", desc: "Kurumsal ölçek için.", features: ["Aylık 10.000+ analiz", "Sınırsız scraper", "Sınırsız AI Agent", "Özel SLA ve API", "Atanmış müşteri yöneticisi"] },
      },
    },
    faq: {
      eyebrow: "Sıkça Sorulanlar",
      title: "Sıkça sorulan sorular",
      items: [
        { q: "Aboneliği istediğim zaman iptal edebilir miyim?", a: "Evet, panel üzerinden tek tıkla iptal edebilirsiniz. Kalan dönem boyunca hizmet devam eder." },
        { q: "Verilerim nerede saklanıyor?", a: "Avrupa (Frankfurt) ve ABD (Virginia) bölgelerinde, AES-256 ile şifrelenerek. Her müşteri için ayrı tenant." },
        { q: "API erişimi sağlıyor musunuz?", a: "Tüm planlarda REST API mevcuttur. Pro ve Enterprise planlar webhook desteği içerir." },
        { q: "Özelleştirilmiş AI Agent yazabiliyor musunuz?", a: "Enterprise planda sizin alanınıza özel ajanlar tasarlıyor ve eğitiyoruz." },
      ],
    },
    contact: {
      eyebrow: "İletişim",
      title: "Konuşalım.",
      desc: "Demo, fiyatlandırma veya iş ortaklığı için bize yazın.",
      name: "Ad Soyad", email: "E-posta", company: "Şirket (opsiyonel)", message: "Mesajınız", submit: "Gönder",
      success: "Mesajınız alındı, en kısa sürede dönüş yapacağız.",
      email_addr: "support@aqiontech.com",
      phone: "",
      address: "İstanbul, Türkiye",
    },
    footer: { rights: "Tüm hakları saklıdır.", made: "Aqion Technologies" },
    auth: {
      login_title: "Hesabınıza giriş yapın",
      register_title: "Aqion'a katılın",
      email: "E-posta", password: "Şifre", name: "Ad Soyad",
      login_btn: "Giriş Yap", register_btn: "Hesap Oluştur",
      no_account: "Hesabınız yok mu?", have_account: "Hesabınız var mı?",
      to_register: "Kayıt olun", to_login: "Giriş yapın",
      forgot: "Şifrenizi mi unuttunuz?",
      forgot_title: "Şifrenizi sıfırlayın",
      forgot_desc: "E-posta adresinizi girin, size sıfırlama bağlantısı gönderelim.",
      forgot_submit: "Sıfırlama bağlantısı gönder",
      forgot_sent: "Bu e-posta kayıtlıysa sıfırlama bağlantısı gönderildi.",
      reset_title: "Yeni şifre belirleyin",
      reset_desc: "Yeni şifreniz en az 6 karakter olmalı.",
      reset_submit: "Şifreyi güncelle",
      reset_success: "Şifreniz güncellendi. Giriş yapabilirsiniz.",
      side_eyebrow: "Veri Zekâsı Motoru",
      side_text: "Veri yığınından strateji çıkarın. Aqion ile karar veren ekipler arasına katılın.",
      login_success: "Giriş başarılı.",
      register_success: "Hesabınız oluşturuldu.",
      google: "Google ile Devam Et",
      or: "veya",
    },
    profile: {
      title: "Profil ve Ayarlar",
      account: "Hesap Bilgileri",
      subscription: "Abonelik",
      password: "Şifre",
      name: "Ad Soyad",
      email: "E-posta",
      save: "Kaydet",
      current_password: "Mevcut şifre",
      new_password: "Yeni şifre",
      change_password: "Şifreyi Güncelle",
      current_plan: "Aktif plan",
      renew: "Planı Yenile",
      cancel_sub: "Aboneliği İptal Et",
      cancel_confirm: "Aboneliğinizi iptal etmek istediğinizden emin misiniz?",
      cancel_note: "İptal ederseniz plan hemen ücretsize düşer, iade yapılmaz.",
      name_updated: "İsim güncellendi.",
      password_updated: "Şifre güncellendi.",
      subscription_cancelled: "Aboneliğiniz iptal edildi.",
      no_active: "Aktif aboneliğiniz yok.",
    },
    dashboard: {
      welcome: "Hoş geldiniz",
      plan: "Plan", quota: "Kota", used: "Kullanıldı",
      services_title: "Servisler", upgrade: "Planı Yükselt",
      open: "Aç", current: "Aktif Plan", expires: "Bitiş",
      free: "Ücretsiz",
      back: "Panele Dön",
      download: "Uygulamayı İndir",
      download_soon: "Yakında",
      download_note: "Bu hizmet bir masaüstü uygulaması olarak sunulmaktadır. İndirme bağlantısı kısa süre içinde aktif olacaktır.",
      service_titles: {
        company: "Şirket Analizi", seo: "SEO Analizi",
        scraper: "Web Scraper", agent: "AI Agent",
      },
      service_desc: {
        company: "Detaylı şirket analizi: finansal görünüm, pazar konumu, rakip kıyaslama ve risk profili. Masaüstü uygulamasını indirip lisans anahtarınızla başlayın.",
        seo: "Teknik SEO denetimi, anahtar kelime fırsatları ve içerik stratejisi. Masaüstü uygulamasını indirin, panelinizden lisanslayın.",
        scraper: "Antibot atlatmalı zamanlanabilir veri toplama. Yapılandırılmış JSON ve CSV çıktısı. Masaüstü uygulamasını indirin.",
        agent: "Hedef tanımlayın, otonom AI ajanı 7/24 çalıştırsın. Masaüstü uygulamasını indirip ajanlarınızı tasarlamaya başlayın.",
      },
      requirements: "Sistem gereksinimleri",
      reqs_list: ["Windows 10/11 · macOS 12+ · Linux", "8 GB RAM önerilir", "İnternet bağlantısı (lisans doğrulama)"],
      reports: "Analiz Geçmişi",
      reports_open: "Raporları Gör",
      reports_empty: "Henüz analiz raporu üretmediniz. Bir hizmet seçip analizi başlatın.",
      reports_view: "Görüntüle",
      reports_back: "Listeye Dön",
    },
    gate: {
      title: "Aqion aboneliği gerekli",
      subtitle: "Bu araç yalnızca aktif aboneliği olan üyelere açıktır.",
      body: "Şirket analizi, SEO denetimi, web scraper ve otonom AI ajanı hizmetlerine erişmek için Starter, Pro veya Enterprise planlarından birini seçin.",
      cta: "Planları İncele",
      back: "Panele Dön",
    },
    admin: {
      title: "Yönetim Paneli",
      stats_title: "İstatistikler",
      contacts_title: "İletişim Mesajları",
      users_title: "Kullanıcılar",
      payments_title: "Ödeme İşlemleri",
      total_users: "Toplam Kullanıcı",
      paid_users: "Ödemeli Üye",
      total_contacts: "Toplam Mesaj",
      total_payments: "Tamamlanan Ödeme",
      total_calls: "Servis Çağrısı",
      empty: "Kayıt yok.",
      delete: "Sil",
      role: "Rol", plan: "Plan", joined: "Katılım", actions: "İşlem",
      change_role: "Rol değiştir",
      change_plan: "Plan değiştir",
      confirm_delete: "Silmek istediğinizden emin misiniz?",
      amount: "Tutar", status: "Durum", session: "Oturum", date: "Tarih",
    },
    payment: {
      checking: "Ödeme durumu kontrol ediliyor...",
      success: "Ödeme başarılı! Aboneliğiniz aktif.",
      failed: "Ödeme tamamlanamadı.",
      cancelled: "Ödeme iptal edildi.",
      back: "Panele Git",
    },
    modal: {
      services_cta: "Hizmetlere git",
      auth_register_pitch: "Aqion'a katılın — saniyeler içinde kurulum, kart bilgisi gerekmiyor.",
      auth_dashboard_pitch: "Panele giderek hizmetlerinizi yönetin.",
    },
  },
  en: {
    nav: { services: "Services", pricing: "Pricing", about: "About", contact: "Contact", login: "Login", register: "Sign Up", dashboard: "Dashboard", logout: "Logout", profile: "Profile" },
    hero: {
      eyebrow: "B2B • Data Intelligence Platform",
      title_a: "Make your",
      title_b: "digital footprint",
      title_c: "measurable.",
      subtitle: "Aqion unifies deep company analysis, SEO audits, web scraping and autonomous AI agents into a single subscription.",
      cta_primary: "Start Free",
      cta_secondary: "Explore Services",
    },
    marquee: ["Company Analysis", "SEO Audits", "Web Scraping", "AI Agents", "Real-time Intelligence", "API & PDF Reports", "Multi-region"],
    services: {
      eyebrow: "Services",
      title: "One platform. Four engines.",
      desc: "Enterprise-grade modules built for decision support.",
      details: "Details",
      items: [
        { key: "company", title: "Company Analysis", desc: "Financials, market position, competitor benchmarking and risk profile. PDF and API output." },
        { key: "seo", title: "SEO Analysis", desc: "Technical SEO, keyword opportunities, content strategy and backlink audit." },
        { key: "scraper", title: "Web Scraper", desc: "Anti-bot bypass, schedulable collectors. Structured JSON and CSV output." },
        { key: "agent", title: "AI Agent", desc: "Goal-oriented autonomous agents that run your workflows 24/7." },
      ],
    },
    features: [
      { icon: "zap", title: "Real-time intelligence", desc: "Data lands in your dashboard within minutes." },
      { icon: "shield", title: "Enterprise security", desc: "Aligned with ISO 27001. Encrypted at rest, isolated tenants." },
      { icon: "globe", title: "Multi-region", desc: "EU + US data centres, processing in 12 languages." },
      { icon: "spark", title: "Autonomous agents", desc: "Define a goal, agents handle execution." },
    ],
    about: {
      eyebrow: "Why Aqion",
      title: "From data to decision, automatically.",
      desc: "Replace static reports with live intelligence. Watch rivals, catch openings, dispatch agents.",
      stats: [
        { v: "1.2M+", l: "Monthly data requests" },
        { v: "99.7%", l: "SLA uptime" },
        { v: "<3 min", l: "Report generation" },
        { v: "EU+US", l: "Data centres" },
      ],
    },
    testimonials: {
      eyebrow: "Trusted by leaders",
      title: "Outcome-driven teams run on Aqion.",
      items: [
        { quote: "Aqion took our competitor analysis from weeks to hours.", who: "Defne Aksoy", role: "CMO, Kuzey Holding" },
        { quote: "The AI Agent module runs our content calendar end-to-end.", who: "Mert Erkan", role: "Head of Growth, Lumen" },
        { quote: "Best-in-class anti-bot scraper performance — nothing comes close.", who: "Aslı Demir", role: "Data Lead, Orbit" },
      ],
    },
    pricing: {
      eyebrow: "Pricing",
      title: "A plan that fits.",
      desc: "Monthly subscription. Cancel anytime.",
      month: "/mo",
      popular: "Popular",
      cta: "Choose plan",
      cta_login: "Sign up to continue",
      goto: "Go to pricing",
      tiers: {
        starter: { name: "Starter", desc: "Solo and small teams.", features: ["100 analyses / mo", "Basic SEO audit", "1 scheduled scraper", "Email support"] },
        pro: { name: "Pro", desc: "Growing teams and agencies.", features: ["1,000 analyses / mo", "Advanced SEO and competitor tracking", "10 scheduled scrapers", "1 AI Agent", "Priority support"] },
        enterprise: { name: "Enterprise", desc: "Corporate scale.", features: ["10,000+ analyses / mo", "Unlimited scrapers", "Unlimited AI Agents", "Custom SLA and API", "Dedicated CSM"] },
      },
    },
    faq: {
      eyebrow: "FAQ",
      title: "Frequently asked questions",
      items: [
        { q: "Can I cancel anytime?", a: "Yes — one click from your dashboard. Service continues until the period ends." },
        { q: "Where is my data stored?", a: "EU (Frankfurt) and US (Virginia), AES-256 encrypted, fully tenant-isolated." },
        { q: "Do you provide API access?", a: "Every plan ships with a REST API. Pro and Enterprise add webhooks." },
        { q: "Can you build custom AI agents?", a: "On Enterprise we design and train domain-specific agents tailored to you." },
      ],
    },
    contact: {
      eyebrow: "Contact",
      title: "Let's talk.",
      desc: "Reach out for a demo, pricing or partnerships.",
      name: "Name", email: "Email", company: "Company (optional)", message: "Your message", submit: "Send",
      success: "Message received. We will get back to you shortly.",
      email_addr: "support@aqiontech.com",
      phone: "",
      address: "Istanbul, Türkiye",
    },
    footer: { rights: "All rights reserved.", made: "Aqion Technologies" },
    auth: {
      login_title: "Sign in to your account",
      register_title: "Join Aqion",
      email: "Email", password: "Password", name: "Full name",
      login_btn: "Sign In", register_btn: "Create Account",
      no_account: "Don't have an account?", have_account: "Already have an account?",
      to_register: "Register", to_login: "Sign in",
      forgot: "Forgot your password?",
      forgot_title: "Reset your password",
      forgot_desc: "Enter your email and we'll send a reset link.",
      forgot_submit: "Send reset link",
      forgot_sent: "If the email is registered, a reset link has been sent.",
      reset_title: "Set a new password",
      reset_desc: "Your new password must be at least 6 characters.",
      reset_submit: "Update password",
      reset_success: "Password updated. You can sign in now.",
      side_eyebrow: "Intelligence Engine",
      side_text: "Turn raw data into strategy. Join the teams that decide with Aqion.",
      login_success: "Signed in.",
      register_success: "Account created.",
      google: "Continue with Google",
      or: "or",
    },
    profile: {
      title: "Profile & Settings",
      account: "Account",
      subscription: "Subscription",
      password: "Password",
      name: "Full name",
      email: "Email",
      save: "Save",
      current_password: "Current password",
      new_password: "New password",
      change_password: "Update password",
      current_plan: "Active plan",
      renew: "Renew plan",
      cancel_sub: "Cancel subscription",
      cancel_confirm: "Are you sure you want to cancel your subscription?",
      cancel_note: "Cancelling drops you back to Free immediately. No refund is issued.",
      name_updated: "Name updated.",
      password_updated: "Password updated.",
      subscription_cancelled: "Subscription cancelled.",
      no_active: "You don't have an active subscription.",
    },
    dashboard: {
      welcome: "Welcome",
      plan: "Plan", quota: "Quota", used: "Used",
      services_title: "Services", upgrade: "Upgrade plan",
      open: "Open", current: "Active plan", expires: "Expires",
      free: "Free",
      back: "Back to dashboard",
      download: "Download app",
      download_soon: "Coming soon",
      download_note: "This service is delivered as a desktop application. The download link will be available shortly.",
      service_titles: {
        company: "Company Analysis", seo: "SEO Analysis",
        scraper: "Web Scraper", agent: "AI Agent",
      },
      service_desc: {
        company: "Deep company analysis: financial outlook, market position, competitor benchmarking and risk profile. Download the desktop app and activate it with your license key.",
        seo: "Technical SEO audit, keyword opportunities and content strategy. Download the desktop app and license it from your panel.",
        scraper: "Anti-bot bypass and schedulable data collection. Structured JSON & CSV output. Download the desktop application.",
        agent: "Define a goal; an autonomous AI agent runs 24/7. Download the desktop app to design your agents.",
      },
      requirements: "System requirements",
      reqs_list: ["Windows 10/11 · macOS 12+ · Linux", "8 GB RAM recommended", "Internet connection (license check)"],
      reports: "Analysis History",
      reports_open: "View Reports",
      reports_empty: "You haven't generated any analysis yet. Pick a service and run an analysis.",
      reports_view: "View",
      reports_back: "Back to list",
    },
    gate: {
      title: "Aqion subscription required",
      subtitle: "This tool is only available to members with an active subscription.",
      body: "Choose a Starter, Pro or Enterprise plan to access company analysis, SEO audits, web scraper and autonomous AI agents.",
      cta: "See plans",
      back: "Back to dashboard",
    },
    admin: {
      title: "Admin Panel",
      stats_title: "Statistics",
      contacts_title: "Contact Messages",
      users_title: "Users",
      payments_title: "Payment Transactions",
      total_users: "Total Users",
      paid_users: "Paying Users",
      total_contacts: "Total Messages",
      total_payments: "Completed Payments",
      total_calls: "Service Calls",
      empty: "No records.",
      delete: "Delete",
      role: "Role", plan: "Plan", joined: "Joined", actions: "Action",
      change_role: "Change role",
      change_plan: "Change plan",
      confirm_delete: "Are you sure you want to delete?",
      amount: "Amount", status: "Status", session: "Session", date: "Date",
    },
    payment: {
      checking: "Checking payment status...",
      success: "Payment successful! Subscription active.",
      failed: "Payment could not be completed.",
      cancelled: "Payment cancelled.",
      back: "Go to dashboard",
    },
    modal: {
      services_cta: "Go to services",
      auth_register_pitch: "Join Aqion — set up in seconds, no credit card required.",
      auth_dashboard_pitch: "Open your dashboard to manage your services.",
    },
  },
};
